export default __webpack_public_path__ + "static/media/BlackFavourite.113acedb.svg";